import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import AuditionAudioStore from '@src/pages/audition-audio/store';
import Page from '../../components/page';
import InnerWrap from '../inner-wrap';
import Link from '@src/components/link';
import { Slider } from 'antd';
import cx from 'classnames';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const AuditionAudio = () => {
  const store = useStore(() => new AuditionAudioStore());

  return (
    <Page className={styles.root}>
      <InnerWrap store={store.innerWrapStore}>
        <div className={styles.audioContent}>
          <div className={styles.audio}>
            <div className={styles.record} data-name="唱片">
              <div className={cx(styles.black, store.isPlaying && styles.rotateani)} />
              <div className={styles.poster} />
            </div>
            <div className={styles.audioSwiper}>
              <div className={styles.audioSwiperWrap}>
                {Array.from({ length: Math.ceil(store.musicList.length / store.pageSize) }).map((_, index) => {
                  if (index !== store.current) {
                    return null;
                  }
                  return (
                    <div className={styles.swiperItem} key={index}>
                      <div className={styles.audioList}>
                        {store.musicList.map((item, i) => {
                          // 每一页显示6条，以此类推 是使用current判断
                          if (!(i >= index * store.pageSize && i < (index + 1) * store.pageSize)) {
                            return null;
                          }
                          return (
                            <div
                              className={cx(styles.audioItem, store.currentMusicIndex === i && styles.active, store.isPlaying && styles.playing)}
                              key={item.id}
                              onClick={() => {
                                $$tracker.clickStzxChangeMusic(item.title);
                                store.selectMusic(i);
                              }}
                              data-name="选择音乐"
                            >
                              <div className={styles.audioInfo}>
                                <div className={styles.title}>
                                  <span className={cx(store.isPlaying ? styles.rotateani : '')} />
                                  {item.title}
                                </div>
                                <div className={styles.singer}>{item.singer}</div>
                                <div className={styles.duration}>{item.duration}</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>

              {store.musicList.length > store.pageSize && (
                <div className={styles.pagination}>
                  <Link className={cx(styles.paginationBtn, styles.paginationPrev)} onClick={() => store.setCurrent('prev')} />
                  <div className={styles.paginationCenter}>
                    {Array.from({ length: Math.ceil(store.musicList.length / store.pageSize) }).map((_, index) => (
                      <div
                        key={index}
                        className={cx(styles.dot, store.current === index && styles.active)}
                        onClick={() => {
                          store.setCurrent(index);
                        }}
                      />
                    ))}
                  </div>
                  <Link className={cx(styles.paginationBtn, styles.paginationNext)} onClick={() => store.setCurrent('next')} />
                </div>
              )}
            </div>
          </div>

          <div className={styles.audioControl} data-name="音乐进度">
            <div className={styles.controlInfo}>
              <div className={styles.controlTitle}>{store.currentMusic?.title || ''}</div>
              <div className={styles.controlSinger}>{store.currentMusic?.singer || ''}</div>
            </div>
            <div className={styles.sliderWrap}>
              <div className={styles.currentTime}>{store.formatDuration(store.currentDuration || 0)}</div>
              <div className={styles.sliderBox}>
                <Slider
                  className={styles.slider}
                  value={store.currentDuration || 0}
                  max={store.duration || 0}
                  onChange={store.setCurrentTime}
                  tooltipVisible={false}
                  tipFormatter={null}
                />
              </div>
              <div className={styles.MaxTime}>{store.formatDuration(store.duration || 0)}</div>
            </div>
            <div className={styles.controlBtn} onClick={store.playPause} data-name="播放/暂停">
              <Link className={cx(styles.controlBtn, styles.controlPrev)} onClick={() => store.selectMusic('prev')} />
              <div className={styles.controlCenter}>
                <Link
                  className={cx(styles.controlCenterBtn, styles.controlPlay, !store.isPlaying && styles.show)}
                  onClick={() => {
                    $$tracker.clickStzxPlayMusic(store.currentMusic?.title || '');
                    store.playAudio(true);
                  }}
                />
                <Link className={cx(styles.controlCenterBtn, styles.controlPause, store.isPlaying && styles.show)} onClick={() => store.playAudio(false)} />
              </div>
              <Link className={cx(styles.controlBtn, styles.controlNext)} onClick={() => store.selectMusic('next')} />
            </div>
          </div>
        </div>

        <div style={{ display: 'none' }}>
          <audio src={store.currentMusic?.url || ''} ref={ref => (store.audioRef = ref)} />
        </div>
      </InnerWrap>
    </Page>
  );
};

export default observer(AuditionAudio);
